import { PagiantedQuestionsType } from "@/api/verification";
import useSWR from "@/hooks/useSWR";

export default function useVerificationQuestions({
  flowType,
  flowId,
  answer__isnull,
}: {
  flowType?: "acceptable_use_violation" | "fraudulent_payment";
  flowId?: number;
  answer__isnull?: boolean;
}) {
  const queryString = new URLSearchParams();
  if (answer__isnull) {
    queryString.set("answer__isnull", answer__isnull.toString());
  }
  if (flowType) {
    queryString.set("flow__type", flowType);
  }
  if (flowId) {
    queryString.set("flow__id", flowId.toString());
  }
  return useSWR<PagiantedQuestionsType>(
    `/verification/question/?${queryString.toString()}`
  );
}
